export const login = {
    VALIDAACESSO: 'VALIDAACESSO',
    ATUALIZALOGIN: 'ATUALIZALOGIN',
    CODIGO_RESETSENHA: 'CODIGO_RESETSENHA',
    PESQUISA: 'PESQUISA',
    INICIALOGIN: 'INICIALOGIN',
    CODIGO_VALIDACAD: 'CODIGO_VALIDACAD',
    VALIDACAD: 'VALIDACAD'
}